/**
 * whatsapp-pdp.js
 * Keeps every PDP-context WhatsApp link in sync with the currently selected
 * variant. Targets:
 *   - The Fit Concierge card    →  a[data-location="pdp_fit_concierge"]
 *   - The size-confidence link  →  a[data-location="pdp_size_confidence"]
 *     (only emits the data attrs when the merchant hasn't overridden with a
 *     custom non-WA link, so the selector naturally only matches WA mode)
 *   - The floating fitter pill  →  a[data-location="floating_fitter"][data-product-id]
 *     (the [data-product-id] predicate guards on-PDP only — server-side that
 *     attribute is emitted only when request.page_type == 'product' and product)
 *
 * Pattern:
 *   - Reads product data from <script id="salud-product-data" type="application/json">
 *     (rendered server-side in sections/main-product.liquid).
 *   - Listens for `change` on input[name="id"] inside the product form
 *     (Dawn's variant-radios / variant-selects update this hidden input).
 *   - Diffs old variant.options vs new variant.options to produce a
 *     variant_suffix of the form " (Color, Size)".
 *   - Replaces the suffix in each anchor's decoded `?text=` param, re-encodes,
 *     and writes the new href + data-variant-id back.
 *
 * Graceful no-op if any required element is missing.
 */
(function () {
  'use strict';

  var ANCHOR_SELECTOR = 'a[data-location="pdp_fit_concierge"], a[data-location="pdp_size_confidence"], a[data-location="floating_fitter"][data-product-id]';

  function suffixFor(variant, hasOnlyDefault) {
    if (!variant || hasOnlyDefault) return '';
    var opts = (variant.options || []).filter(function (o) { return !!o; });
    if (!opts.length) return '';
    return ' (' + opts.join(', ') + ')';
  }

  function init() {
    var dataNode = document.getElementById('salud-product-data');
    var anchors = document.querySelectorAll(ANCHOR_SELECTOR);
    if (!dataNode || !anchors.length) return;

    var product;
    try {
      product = JSON.parse(dataNode.textContent);
    } catch (e) {
      return;
    }
    if (!product || !Array.isArray(product.variants)) return;

    var hasOnlyDefault = !!product.has_only_default_variant;

    // Locate the form's hidden id input. Dawn updates this on variant change.
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;

    function findVariant(id) {
      id = String(id);
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === id) return product.variants[i];
      }
      return null;
    }

    function updateAnchor(anchor, newVariantId) {
      var oldVariantId = anchor.dataset.variantId;
      if (!newVariantId || String(newVariantId) === String(oldVariantId)) return;

      var oldVariant = findVariant(oldVariantId);
      var newVariant = findVariant(newVariantId);
      if (!newVariant) return;

      var oldSuffix = suffixFor(oldVariant, hasOnlyDefault);
      var newSuffix = suffixFor(newVariant, hasOnlyDefault);

      var url;
      try {
        url = new URL(anchor.href);
      } catch (e) {
        return;
      }
      var text = url.searchParams.get('text') || '';

      if (oldSuffix && text.indexOf(oldSuffix) !== -1) {
        text = text.replace(oldSuffix, newSuffix);
      } else if (!oldSuffix && newSuffix) {
        text += newSuffix;
      }
      // If oldSuffix not found (e.g. message edited), bail — don't corrupt the link.
      url.searchParams.set('text', text);
      anchor.href = url.toString();
      anchor.dataset.variantId = String(newVariantId);
    }

    idInput.addEventListener('change', function () {
      var newId = idInput.value;
      for (var i = 0; i < anchors.length; i++) {
        updateAnchor(anchors[i], newId);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
